.face {
  font: normal 1.5rem/1 "Space Mono", monospace;
  height: 1.5rem;
}
